import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HireBanner.css";
import bannerImg from "../../../../Assets/Images/Services/Dev For Hire/image2.jpg";
import { Link } from "react-router-dom";
export const HireBanner = () => {
  return (
    <div className="banner">
      <div className="banner-title-desc-btn text-start">
        <h1 className="banner-title">Developers Who Actually Integrate</h1>
        <p className="banner-desc">
          Most hiring crumbles when the actual work starts. Our developers for
          hire in Bangladesh join your product when the context matters most.
          They learn your system, challenge weak ideas, and stay involved long
          enough to carry decisions forward rather than resetting progress every
          few weeks.
        </p>
        <div className="banner-btn">
          <Link to="/contact-us/hiring-team">
            <button className="btn-1">Hire Solo developer</button>
          </Link>
          <Link to="/contact-us/hiring-team">
            <button className="btn-2">Build A team</button>
          </Link>
        </div>
      </div>
      <div className="banner-img">
        <img src={bannerImg} alt="Banner-Img" className="img-fluid" />
      </div>
    </div>
  );
};
